(() => {
  if (window.productCardVideoAutoplay) {
    window.productCardVideoAutoplay.observe(document);
    return;
  }

  const observedVideos = new WeakSet();
  const visibleVideos = new Set();

  const play = (video) => {
    video.muted = true;
    video.preload = 'metadata';
    const request = video.play();
    if (request !== undefined) request.catch(() => {});
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            visibleVideos.add(video);
            if (!document.hidden) play(video);
          } else {
            visibleVideos.delete(video);
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 })
    : null;

  const observe = (root) => {
    root.querySelectorAll?.('.card-product__autoplay-video').forEach((video) => {
      if (observedVideos.has(video)) return;
      observedVideos.add(video);
      video.muted = true;
      if (observer) observer.observe(video);
      else {
        visibleVideos.add(video);
        play(video);
      }
    });
  };

  document.addEventListener('visibilitychange', () => {
    visibleVideos.forEach((video) => {
      if (document.hidden) video.pause();
      else play(video);
    });
  });

  document.addEventListener('shopify:section:load', (event) => observe(event.target));

  window.productCardVideoAutoplay = { observe };
  observe(document);
})();
